<template>
    <Nav />
    <div class="speaker-detail">
        <div class="speaker-detail-container">
            <div class="title">
                <h3>
                    <em></em>
                    <span>{{ t('speakers.title') }}</span>
                    <em></em>
                </h3>
            </div>
            <div class="video" v-if="speaker.video_url">
                <video :src="speaker.video_url" controls preload="auto" class="speaker-video"></video>
            </div>
            <div class="speaker-info">
                <div class="speaker-info-left">
                    <img :src="previewFile(speaker.avatar)" :alt="getSpeakerName(speaker)">
                </div>
                <div class="speaker-info-right">
                    <h1>{{ getSpeakerName(speaker) }}</h1>
                    <p v-html="getSpeakerBio(speaker)"></p>
                </div>
            </div>
            <GoHome />

        </div>
    </div>
    <Footer />
</template>

<script setup>
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n()


import { ref, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import Nav from '@/components/Nav.vue'
import Footer from '@/components/Footer.vue'
import GoHome from '@/components/GoHome.vue'

import { getSpeaker } from '@/api/speaker'
import { previewFile } from '@/utils/uploadedPreview'


const route = useRoute()
const speakerId = ref(route.params.id)

const speaker = ref({})

const getSpeakerName = (speaker) => {
    if (locale.value === 'en') {
        // 英文环境：优先显示name_en，不存在时显示name_zh
        return speaker.name_en || speaker.name_zh
    } else {
        // 中文环境：优先显示name_zh，不存在时显示name_en
        return speaker.name_zh || speaker.name_en
    }
}

const getSpeakerBio = (speaker) => {
    const bio = locale.value === 'en' ? (speaker.bio_en || speaker.bio_zh) : (speaker.bio_zh || speaker.bio_en)
    // 识别并保留文本中的换行，使用 <br> 标签渲染
    return bio ? bio.replace(/\n/g, '<br>') : ''
    // // 在遇到中英文逗号时换行，使用HTML换行标签
    // return bio ? bio.replace(/[,，]/g, '$&<br>') : ''
}

// 封装数据请求逻辑
const fetchSpeakerData = async (id) => {
    if (!id || !locale.value) return // 确保ID和locale都有效再请求
    try {
        const res = await getSpeaker(id)
        speaker.value = res.data
    } catch (error) {
        console.error('获取speaker数据失败:', error)
    }
}

document.title = t('speakers.title')

onMounted(async () => {
    await fetchSpeakerData(speakerId.value)
    localStorage.setItem('language', 'en')
    locale.value = 'en'
})
</script>


<style scoped lang="scss">
.speaker-detail {
    width: 100%;

    .speaker-detail-container {
        max-width: 1440px;
        padding: 40px 0;
        margin: 0 auto;

    }

    .title {
        h3 {
            font-size: 30px;
            font-weight: bold;
            text-align: center;
            color: #303030;
            margin-bottom: 60px;

            span {
                margin: 0 40px;
            }

            em {
                display: inline-block;
                width: 54px;
                height: 14px;
                margin-bottom: 0;
                background: url('@/assets/tt.png');
                vertical-align: middle;
            }
        }
    }

    .video {
        width: 70%;
        margin: 0 auto 40px;

        video {
            width: 100%;
        }
    }

    .speaker-info {
        width: 100%;
        border-top: 1px solid #f3f3f3;
        border-bottom: 1px solid #f3f3f3;
        padding: 40px 0;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 50px;

        .speaker-info-left {
            img {
                width: 280px;
                // height: 344px;
                height: auto;
            }
        }

        .speaker-info-right {
            h1 {
                font-size: 30px;
                font-weight: bold;
                color: #303030;
                margin-bottom: 20px;
            }

            p {
                font-size: 14px;
                color: #303030;
                margin-bottom: 0px;
            }
        }
    }

}

@media (max-width: 768px) {
    .title {
        em {
            width: 40px !important;
        }

        span {
            font-size: 22px;
            margin: 0 10px !important;
        }
    }

    .video {
        width: 90% !important;
        margin: 0 auto 20px !important;
    }

    .speaker-info {
        flex-direction: row;
        align-items: center;
        gap: 10px !important;
        padding: 20px !important;

        .speaker-info-left {
            width: 20% !important;

            img {
                width: 100% !important;
                height: auto !important;
            }
        }

        .speaker-info-right {
            h1 {
                font-size: 24px !important;
                margin-bottom: 10px !important;
            }

            p {
                font-size: 14px !important;
            }
        }
    }
}
</style>